import React from 'react';

export interface ICustomToken {
	type: 'ERC20';
	options: {
		address: string;
		symbol: string;
		decimals: number;
		image: string;
	};
}

export const USDCToken: ICustomToken = {
	type: 'ERC20',
	options: {
		address: '0x2791Bca1f2de4661ED88A30C99A7a9449Aa84174',
		symbol: 'USDC',
		decimals: 6,
		image: 'https://thegivingblock.com/wp-content/uploads/2021/11/usd-coin-usdc-logo-1.png',
	},
};

const useCustomTokens = () => {
	const addCustomToken = async (token: ICustomToken) => {
		const w = window as any;
		try {
			return await w.ethereum.request({
				method: 'wallet_watchAsset',
				params: { ...token },
			});
		} catch (e) {
			throw e;
		}
	};

	return { addCustomToken };
};

export default useCustomTokens;
